import { useSelector } from 'react-redux'
import { Navigate, Route, RouteObject, Routes } from 'react-router'

import { PublicRouteUrls } from '@/config/constants/routes-urls'
import {
  PRIVATE_ROUTES_CONTENT,
  PUBLIC_ROUTES_CONTENT
} from '@/config/routes-content'
import { RootState } from '@/store/StoreRoot'

import { RoutesContentProps } from './types'
import { getAllowedRoutes, getFirstAllowedPath } from './utils'

const getContentRoutes = (content: RouteObject[]) => (
  <>
    {content.map((route, index) => {
      if (route.index) {
        return <Route key={index} index element={route.element} />
      }

      return (
        <Route key={index} path={route.path} element={route.element}>
          {route.children && getContentRoutes(route.children)}
        </Route>
      )
    })}
  </>
)

const RoutesContent = ({ content, fallbackPath }: RoutesContentProps) => (
  <Routes>
    {getContentRoutes(content)}
    <Route
      path='*'
      element={
        fallbackPath ? (
          <Navigate to={fallbackPath} />
        ) : (
          <p>No tienes acceso a ninguna pantalla.</p>
        )
      }
    />
  </Routes>
)

const Main = () => {
  const { authenticated, credentials } = useSelector(
    (store: RootState) => store.session
  )

  const allowedRoutesContent = getAllowedRoutes(
    PRIVATE_ROUTES_CONTENT,
    credentials
  )

  return authenticated ? (
    <RoutesContent
      content={allowedRoutesContent}
      fallbackPath={getFirstAllowedPath(credentials)}
    />
  ) : (
    <RoutesContent
      content={PUBLIC_ROUTES_CONTENT}
      fallbackPath={PublicRouteUrls.LOGIN}
    />
  )
}

export default Main
